<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "OutputCategories" });
import Chiplist from "../../../../elements/chip-list/ChipList.svelte";
import CategoryList from "../../modules/list/CategoryList.svelte";
import { SESSION_USER } from "../../../authentication/services/store.js";
export let keys;
export let verticalCode;
export let maxItems = void 0;
export let auctionKey = void 0;
export let subscriptionKey = void 0;
const LANGUAGE_CODE = $SESSION_USER.locale.languageCode;
const STATES = ["created", "approved"];
$: parameters = {
    auctionKey,
    states: STATES,
    subscriptionKey,
    verticalCode: verticalCode === void 0 ? [] : [verticalCode]
};
const getLabel = (categories, key) => {
    const CATEGORY = categories.find((category) => category._.key === key);
    if (CATEGORY === void 0) {
        return key;
    }
    const NAME = CATEGORY.name.find(({ languageCode }) => languageCode === LANGUAGE_CODE);
    if (NAME === void 0) {
        return key;
    }
    return NAME.text;
};
const format = (categories) => {
    if ("code" in categories) {
        return [];
    }
    if (!Array.isArray(keys) || keys.length === 0) {
        return [];
    }
    return categories.filter(({ _ }) => keys.includes(_.key)).map((category, index, list) => ({ label: getLabel(list, category._.key) }));
};
</script>

<CategoryList { parameters } let:categories>
    <!-- TODO: Upgrade Svelte & Fix Typing on Slots  -->
    <!-- eslint-disable-next-line @typescript-eslint/no-unsafe-argument -->
    <Chiplist items = { format(categories) } color = 'neutral' { maxItems }/>
</CategoryList>